var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { Heading, TextPlaceholder, BasePlaceholder } from "@riseart/common";
import { cardArticleCls, cardArticleHorizontalCls, cardArticleVerticalCls, cardArticleReversedCls, cardArticleBoxCls, cardArticleMediaCls, cardArticleContentCls, cardArticleSubtitleCls, cardArticleTitleCls, cardArticleDescriptionCls, cardArticleFooterCls, cardArticleAdditionalCls, cardArticleShareCls, cardArticleStyle1Cls, cardArticleStyle2Cls, cardArticleStyle3Cls, cardArticleStyle4Cls, cardArticleStyle5Cls, cardArticleStyle6Cls } from "./Article.less";
var CardArticle = /* @__PURE__ */ __name(function CardArticle2(_ref) {
  var _ref$className = _ref.className, className = _ref$className === void 0 ? null : _ref$className, displayStyle = _ref.displayStyle, title = _ref.title, _ref$subtitle = _ref.subtitle, subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle, _ref$description = _ref.description, description = _ref$description === void 0 ? null : _ref$description, _ref$author = _ref.author, author = _ref$author === void 0 ? null : _ref$author, date = _ref.date, _ref$share = _ref.share, share = _ref$share === void 0 ? null : _ref$share, children = _ref.children, placeholder = _ref.placeholder, _ref$titleTag = _ref.titleTag, titleTag = _ref$titleTag === void 0 ? "h2" : _ref$titleTag, _ref$subTitleTag = _ref.subTitleTag, subTitleTag = _ref$subTitleTag === void 0 ? "span" : _ref$subTitleTag;
  var STYLE_TO_SETTINGS = {
    style1: {
      className: [cardArticleHorizontalCls, cardArticleStyle1Cls],
      showDescription: true,
      showSubtitle: true,
      showFooter: true,
      titleLevel: 2,
      subtitleLevel: 4
    },
    style2: {
      className: [cardArticleStyle2Cls, cardArticleVerticalCls, cardArticleReversedCls],
      showDescription: true,
      showSubtitle: true,
      showFooter: true,
      titleLevel: 2,
      subtitleLevel: 4
    },
    style3: {
      className: [cardArticleStyle3Cls, cardArticleHorizontalCls],
      showDescription: false,
      showSubtitle: true,
      showFooter: true,
      titleLevel: 3,
      subtitleLevel: 5
    },
    style3reversed: {
      className: [cardArticleStyle3Cls, cardArticleHorizontalCls, cardArticleReversedCls],
      showDescription: false,
      showSubtitle: true,
      showFooter: true,
      titleLevel: 3,
      subtitleLevel: 5
    },
    style4: {
      className: [cardArticleStyle4Cls, cardArticleVerticalCls, cardArticleReversedCls],
      showDescription: false,
      showSubtitle: true,
      showFooter: true,
      titleLevel: 3,
      subtitleLevel: 5
    },
    style5: {
      className: [cardArticleStyle5Cls, cardArticleVerticalCls, cardArticleReversedCls, cardArticleBoxCls],
      showDescription: false,
      showSubtitle: true,
      showFooter: true,
      titleLevel: 3,
      subtitleLevel: 5
    },
    style6: {
      className: [cardArticleStyle6Cls],
      showDescription: true,
      showSubtitle: true,
      showFooter: false,
      titleLevel: 3,
      subtitleLevel: 5
    }
  };
  var settings = STYLE_TO_SETTINGS["style".concat(displayStyle)] || STYLE_TO_SETTINGS.style1;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(cardArticleCls, settings.className, className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: cardArticleContentCls
  }, settings.showSubtitle && (subtitle || placeholder) ? /* @__PURE__ */ React.createElement(Heading, {
    placeholder,
    tag: subTitleTag || "span",
    level: settings.subtitleLevel,
    className: cardArticleSubtitleCls
  }, subtitle || null) : null, title || placeholder ? /* @__PURE__ */ React.createElement(Heading, {
    placeholder,
    tag: titleTag || "h2",
    level: settings.titleLevel,
    className: cardArticleTitleCls
  }, title) : null, settings.showDescription && (description || placeholder) ? /* @__PURE__ */ React.createElement("div", {
    className: cardArticleDescriptionCls
  }, !placeholder ? description : /* @__PURE__ */ React.createElement(TextPlaceholder, null)) : null, settings.showFooter && (author || date || placeholder || share) ? /* @__PURE__ */ React.createElement("div", {
    className: cardArticleFooterCls
  }, author || date || placeholder ? /* @__PURE__ */ React.createElement("span", {
    className: cardArticleAdditionalCls
  }, !placeholder ? /* @__PURE__ */ React.createElement(React.Fragment, null, author, author && date ? " | " : null, date) : /* @__PURE__ */ React.createElement(TextPlaceholder, null)) : null, share ? /* @__PURE__ */ React.createElement("span", {
    className: cardArticleShareCls
  }, share) : null) : null), /* @__PURE__ */ React.createElement("div", {
    className: cardArticleMediaCls
  }, !placeholder ? children : /* @__PURE__ */ React.createElement(BasePlaceholder, null)));
}, "CardArticle");
export {
  CardArticle
};
